export const formatProductTypeForDimensions = (
  sellingType: string | undefined,
) => {
  switch (sellingType) {
    case "Hobs":
      return "hob";
    case "Ovens":
      return "oven";
    case "Microwaves":
      return "microwave";
    case "Cooker Hoods":
      return "cooker hood";
    case "Fridge Freezers":
      return "fridge freezer";
    case "Fridges":
      return "fridge";
    case "Dishwashers":
      return "dishwasher";
    case "Televisions":
      return "television";
    default:
      return "appliance";
  }
};

export const largeElecSellingTypes = [
  "Cooker Hoods",
  "Cookers",
  "Dishwashers",
  "Freezers",
  "Fridge Freezers",
  "Fridges",
  "Hobs",
  "Microwaves",
  "Oven Warming Drawers",
  "Ovens",
  "Televisions",
  "Tumble Dryers",
  "Washer Dryers",
  "Washing Machines",
];
